import { useState } from "react";

const RoomImagesSlider = ({ images }) => { // <-- Вот сюда приходят картинки из RoomsPage


    const [currentIndex, setCurrentIndex] = useState(0);
    // Состояние для отслеживания начала касания для свайпа
    const [touchStartX, setTouchStartX] = useState(null);

    // Убраны неиспользуемые состояния и эффекты из предыдущих версий


    // --- Теперь можно выполнять условную логику или рендеринг ---

    // Используем массив images, который пришел через пропсы
    // const images = [photo1, photo2]; // <--- УДАЛЯЕМ эту строку, используем пропс images

    // Проверяем, что массив изображений передан и не пуст
    if (!images || images.length === 0) {
        // Отобразим placeholder или ничего, если нет картинок
        return <div className="no-images-placeholder-alt">Нет фото</div>; // Используем класс placeholder из стилей RoomsPage
    }

    // --- Остальной код компонента ---

    // Логика навигации
    const goToPrevious = () => {
        setCurrentIndex((prevIndex) => {
            const isFirstSlide = prevIndex === 0;
            return isFirstSlide ? images.length - 1 : prevIndex - 1;
        });
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) => {
            const isLastSlide = prevIndex === images.length - 1;
            return isLastSlide ? 0 : prevIndex + 1;
        });
    };

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    // Логика свайпа
    const handleTouchStart = (event) => {
        setTouchStartX(event.touches[0].clientX);
    };

    const handleTouchEnd = (event) => {
        if (touchStartX === null) return;
        const touchEndX = event.changedTouches[0].clientX;
        const deltaX = touchStartX - touchEndX;
        const minSwipeDistance = 50;

        if (deltaX > minSwipeDistance) {
            goToNext();
        } else if (deltaX < -minSwipeDistance) {
            goToPrevious();
        }
        setTouchStartX(null);
    };

    return (
        // Главный контейнер слайдера
        // Класс slider-container и его стили находятся в CSS RoomsPage
        <div
            className="slider-container" // Этот класс стилизуется в CSS RoomsPage
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >

            {/* Основная область слайдера */}
            <div className="slider-main-area"> {/* Этот класс стилизуется в CSS RoomsPage */}

                {/* Стрелки навигации */}
                {/* Отображаем стрелки только если больше 1 изображения */}
                {images.length > 1 && (
                    <>
                        {/* Классы arrow, left, right стилизуются в CSS RoomsPage */}
                        <div className="arrow left" onClick={goToPrevious}>❰</div>
                        <div className="arrow right" onClick={goToNext}>❱</div>
                    </>
                )}

                {/* Контейнер для тега <img> */}
                {/* Класс slide-image-container и его стили в CSS RoomsPage */}
                <div className="slide-image-container">
                    <img
                        src={images[currentIndex]}
                        alt={`Room ${currentIndex + 1}`}
                        className={`slide-image`}
                    />
                    {/* Оверлей, вотермарк и т.п. если нужны */}
                </div>

                {/* Точки-индикаторы */}
                {/* Отображаем точки только если больше 1 изображения */}
                {images.length > 1 && (
                    <div className="dots-container"> {/* Этот класс стилизуется в CSS RoomsPage */}
                        {images.map((_, slideIndex) => (
                            <div
                                key={slideIndex}
                                className={`dot ${slideIndex === currentIndex ? 'active' : ''}`} // Класс dot и active стилизуются в CSS RoomsPage
                                onClick={() => goToSlide(slideIndex)}
                            >
                                ●
                            </div>
                        ))}
                    </div>
                )}

            </div> {/* Конец .slider-main-area */}

        </div> // Конец .slider-container
    );
};

// Экспортируем компонент под именем RoomImagesSlider
export default RoomImagesSlider;